<template>
  <v-form v-model="valid" ref="mainForm">
    <CaseACocherLive
      code="sans_emploi"
      v-model="sas.sasInscriptionTableau.sansEmploi"
      :live="{ endpoint: 'sas-inscription-tableau', cle: 7709, fileId: sas.sasInscriptionTableau.id }"
      :opqIf="sas.sasAdressesProfessionnelles.filter((e) => !e.inactif).length === 0"
    />
    <data-iterator
      :list="sas.sasAdressesProfessionnelles"
      add-new-text="Ajouter un lieu d'exercice"
      :live="{ endpoint: 'sas-adresses', sasId: sas.id }"
      :icon="$getIcon('job')"
      :valids="valids"
      ref="dataIterator"
      hidePoints
      :optional="sas.sasInscriptionTableau.sansEmploi"
      @deleteItem="checkAffichageRetourALaPratique()"
    >
      <template v-slot:show-mode="{ item }">
        <OrganisationCardContent v-if="item" :organisation="item" />
        <p class="mb-0">{{ item.fonction }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <SearchOrganisation v-if="!item.organisationId" @organisation-selected="organisationSelected(item, $event)"></SearchOrganisation>
        <OrganisationCardContent :organisation="item" />
        <v-checkbox
          class="list_counter_validator my-2 ml-6 p-0"
          :input-value="!!item.organisationId"
          :rules="[(v) => !!v || 'Veuillez sélectionner une organisation']"
        ></v-checkbox>
        <TextFieldLive
          v-if="estAutreTypeDeConsultation(item.categorieEtablissement)"
          code="pro_fonction"
          v-model="item.fonction"
          :live="{ endpoint: 'sas-adresses', cle: 5818, fileId: item.id }"
        />
      </template>
    </data-iterator>
    <CatalogueLive
      code="pro_principal"
      :items="sas.sasAdressesProfessionnelles?.map(getTextSasAdresseDropdown)"
      v-model="sas.sasInscriptionTableau.lieuDeTravailPrincipal"
      :live="{ endpoint: 'sas-inscription-tableau', cle: 7711, fileId: sas.sasInscriptionTableau.id }"
      :opqIf="!sas.sasInscriptionTableau.sansEmploi"
    />
    <DomicileProfessionnel :sas="sas" />

    <CatalogueLive
      code="pro_partenariat"
      v-model="sas.sasInscriptionTableau.declarationDUnePratiqueAvanceeEnPartenariat"
      :live="{ endpoint: 'sas-inscription-tableau', cle: 7708, fileId: sas.sasInscriptionTableau.id }"
    />

    <v-alert type="warning" text icon="mdi-alert-circle-outline" class="pl-8 mb-8" max-width="600" v-show="afficherRetourALaPratique">
      <ressource code="avertissement_retour_pratique" />
    </v-alert>
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import RelationSasAdresse from "@/mixins/RelationSasAdresse"
import SearchOrganisation from "@/components/Common/SearchOrganisation.vue"
import OrganisationCardContent from "@/components/Common/OrganisationCardContent.vue"
import DomicileProfessionnel from "@/components/form_parts/DomicileProfessionnel.vue"
import { Queue, Api } from "@/plugins/api"
import { affichageRetourALaPratique } from "@/plugins/services/retourALaPratique"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, RelationSasAdresse],
  components: { SearchOrganisation, OrganisationCardContent, DomicileProfessionnel },
  props: {
    sas: { type: Object }
  },
  data() {
    return {
      afficherRetourALaPratique: false
    }
  },
  mounted() {
    this.checkAffichageRetourALaPratique()
  },
  computed: {},
  methods: {
    organisationSelected(item, org) {
      Queue.enqueue(() =>
        Api.post("sas-adresses", {
          fileId: item.id,
          cle: "300",
          value: org.organisationId
        }).then(() => {
          this.sas.sasAdressesProfessionnelles.splice(this.sas.sasAdressesProfessionnelles.indexOf(item), 1, { ...org, id: item.id })
        })
      )
      this.checkAffichageRetourALaPratique()
    },
    liveSasAdresse(cle) {
      return { endpoint: "sas-assurance", cle: cle, fileId: this.sasAssurance.id }
    },
    estAutreTypeDeConsultation(categorieEtablissement) {
      return this.getCatalogueCodeById("333", categorieEtablissement) == "Autre consultation"
    },
    checkAffichageRetourALaPratique() {
      Queue.enqueue(() =>
        affichageRetourALaPratique(this.sas.id).then((res) => {
          this.afficherRetourALaPratique = res.data.afficherRetourALaPratique
        })
      )
    }
  }
}
</script>

<style>
</style>